import React, { useEffect, useState } from 'react'
import { v2_all_user } from '../../../actions/v2/user';
import customAxios from '../../../customHook/customAxios';
import { getAuthHeader } from '../../../utils';
import fileDownload from 'js-file-download';
import FileDropdownPreviewMenu from '../../common/FileDropdownPreviewMenu';

const decodeMojibake = (value) => {
    if (!value || typeof value !== 'string' || value.includes('�')) return value;

    const decodeOnce = (input) => {
        if (!/[\u00C0-\u00FF]/.test(input)) return input;
        if (typeof TextDecoder === 'undefined' || typeof TextEncoder === 'undefined') return input;

        try {
            const sourceBytes = Uint8Array.from(input, (ch) => ch.charCodeAt(0) & 0xff);
            const decoded = new TextDecoder('utf-8', { fatal: false }).decode(sourceBytes);
            if (!decoded || decoded.includes('\u0000')) return input;

            const reEncoded = new TextEncoder().encode(decoded);
            if (reEncoded.length !== sourceBytes.length) return input;

            for (let i = 0; i < reEncoded.length; i += 1) {
                if (reEncoded[i] !== sourceBytes[i]) return input;
            }

            return decoded;
        } catch (error) {
            return input;
        }
    };

    let current = value;
    for (let i = 0; i < 2; i += 1) {
        const next = decodeOnce(current);
        if (next === current) break;
        current = next;
    }

    return current;
};

const Header = ({ data, revision }) => {

    const [previewItem, setPreviewItem] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [loading, setLoading] = useState(false);

    // useEffect(() => {
    //     const fetchPdf = async () => {
    //         if (!previewItem) return;

    //         setLoading(true);
    //         setPdfUrl(null);

    //         try {
    //             const response = await fetch(
    //                 `${process.env.REACT_APP_BASE_URL}/v3/fat/download/pdf/${previewItem?.ID}`

    //             );

    //             if (!response.ok) throw new Error("Failed to download PDF");

    //             const blob = await response.blob();
    //             const fileUrl = URL.createObjectURL(blob);
    //             setPdfUrl(fileUrl);
    //         } catch (err) {
    //             console.error("PDF Preview Error:", err);
    //         } finally {
    //             setLoading(false);
    //         }
    //     };

    //     fetchPdf();

    //     // cleanup on close
    //     return () => {
    //         if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    //         setPdfUrl(null);
    //     };
    // }, [previewItem]);

    useEffect(() => {
        if (!previewItem) return;

        setLoading(true);

        const url = `${process.env.REACT_APP_BASE_URL}/v3/fat/download/preview/${previewItem.ID}`;

        setPdfUrl(url);
        setLoading(false);

    }, [previewItem]);
    const handleDownload = async (fatId, revisionId) => {
        try {
            const downloadUrl = `${process.env.REACT_APP_BASE_URL}/v3/fat/document/zip/${fatId}/${revisionId}`;
            let config = { responseType: 'blob' }
            const authHeader = getAuthHeader();
            if (authHeader?.headers) {
                config.headers = {
                    ...config.headers,
                    ...authHeader.headers,
                };
            }
            const response = await customAxios.get(downloadUrl, config);

            const blob = new Blob([response.data], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', `fatId_${fatId}_revision_${revisionId}_files.zip`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Download failed:', error?.response?.data || error.message);
            alert("Download failed. Please check if the document has valid files or contact support.");
        }
    };

    const handleDownloadFile = async (fatId, revisionId, fileName) => {
        try {
            const downloadUrl = `${process.env.REACT_APP_BASE_URL}/v3/fat/document/download/${fatId}/${revisionId}/${encodeURIComponent(fileName)}`;
            let config = { responseType: 'blob' };
            const authHeader = getAuthHeader();
            if (authHeader?.headers) {
                config.headers = {
                    ...config.headers,
                    ...authHeader.headers,
                };
            }
            const response = await customAxios.get(downloadUrl, config);
            fileDownload(response.data, fileName);
        } catch (error) {
            console.error('Download failed:', error?.response?.data || error.message);
            alert("Download failed. Please check if the document has valid files or contact support.");
        }
    };

    const revisionId = revision?.ID;
    const revisionFiles = (revision?.documents || []).map((doc, index) => {
        const rawFileName = doc.FILE_NAME || doc.fileName || '';
        const encodedFileName = encodeURIComponent(rawFileName);
        const displayName = decodeMojibake(doc.ORIGINAL_FILE_NAME || doc.originalFileName || rawFileName || `File ${index + 1}`);
        return {
            id: `${rawFileName || 'file'}-${index}`,
            name: displayName,
            previewUrl: rawFileName && revisionId
                ? `${process.env.REACT_APP_BASE_URL}/v3/fat/document/preview/${data.ID}/${revisionId}/${encodedFileName}`
                : '',
            downloadUrl: rawFileName && revisionId
                ? `${process.env.REACT_APP_BASE_URL}/v3/fat/document/download/${data.ID}/${revisionId}/${encodedFileName}`
                : '',
            onDownload: rawFileName && revisionId
                ? () => handleDownloadFile(data.ID, revisionId, rawFileName)
                : null,
        };
    });
    return (
        <div className="plan-approval-top-box">
            <div className="info-about-modle-box">
                <div className="mod-box-info">
                    <h5>Serial No.</h5>
                    <p>{data.ID}</p>
                </div>
                <div className="mod-box-info">
                    <h5>FAT Number</h5>
                    <p>{data.FAT_NUMBER}</p>
                </div>
                <div className="mod-box-info">
                    <h5>Category</h5>
                    <p>{data.CATEGORY_NAME}</p>
                </div>
                <div className="mod-box-info">
                    <h5>Assigned To</h5>
                    <p>{data.ASSIGNED_USER}</p>

                </div>
                <div className="mod-box-info">
                    <h5>Submitted To</h5>
                    <p>{data.SUBMITTED_TO_USER}</p>
                </div>
                {/* <div className="mod-box-info">
                    <h5>Link Documents</h5>
                    <p />
                </div> */}


                {/* <div>
                    <a
                        href={`${process.env.REACT_APP_BASE_URL}/v3/fat/download/:type/:fatId`.replace(':type', 'pdf').replace(':fatId', data?.ID)}
                        className="btn btn-sm btn-primary me-2"
                        target='_blank'
                        style={{
                            backgroundImage:
                                "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                        }}
                    >
                        <i className="fas fa-file label-icon" /> Export as PDF

                    </a>
                </div> */}
                <div className="dropdown">
                    <button
                        type="button"
                        className="btn btn-sm btn-primary dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style={{
                            backgroundImage:
                                "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))",
                        }}
                    >
                        <i className="fas fa-file label-icon" /> Export
                    </button>
                    <ul className="dropdown-menu" >
                        <li>
                            <a
                                href={`${process.env.REACT_APP_BASE_URL}/v3/fat/download/pdf/${data?.ID}`}
                                target="_blank"
                                className="dropdown-item"
                            >
                                PDF
                            </a>
                        </li>
                        <li>
                            <a
                                href={`${process.env.REACT_APP_BASE_URL}/v3/fat/download/docx/${data?.ID}`}
                                target="_blank"
                                className="dropdown-item"
                            >
                                DOC
                            </a>
                        </li>
                        <li>
                            <li>
                                <button
                                    className="dropdown-item"
                                    onClick={() => setPreviewItem(data)}
                                    data-bs-toggle="modal"
                                    data-bs-target="#previewModal"
                                >
                                    Preview
                                </button>
                            </li>
                        </li>


                    </ul>
                </div>
                <div
                    className="modal fade"
                    aria-hidden="true"
                    id="previewModal"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabIndex={-1}
                    role="dialog"
                    aria-labelledby="previewModalLabel"
                >
                    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Preview</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => setPreviewItem(null)}
                                />
                            </div>

                            <div
                                className="modal-body d-flex justify-content-center align-items-center"
                                style={{ height: "80vh" }}
                            >
                                {loading ? (
                                    <div style={{ fontSize: "18px", fontWeight: "500", color: "#555" }}>
                                        Loading...
                                    </div>
                                ) : pdfUrl ? (
                                    <iframe
                                        src={pdfUrl}
                                        title="PDF Preview"
                                        width="100%"
                                        height="100%"
                                        style={{ border: "none" }}
                                    />
                                ) : (
                                    <p className="text-muted">No preview available</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="plan-info-file">
                    <ul>
                        <li>
                            <p>
                                Latest Revisions <span> {revision?.REVISION_NAME}</span>
                            </p>
                        </li>
                        <li>
                            <div className="dropdown hover-dropdown">
                                <p>
                                    Files{" "}
                                    <span
                                        role="button"
                                        className="dropdown-toggle"
                                    >
                                        {revision?.documents?.length} File <i className="bx bx-download" />
                                    </span>
                                </p>
                                <FileDropdownPreviewMenu
                                    files={revisionFiles}
                                    onDownloadAll={() => {
                                        if (data?.ID && revisionId) {
                                            handleDownload(data.ID, revisionId);
                                        }
                                    }}
                                />
                            </div>
                        </li>
                        <li>
                            <p>
                                Subject <span>{data.SUBJECT || 'NA'}</span>
                            </p>
                        </li>
                        <li>
                            <p>
                                Attended By <span>{data?.ATTENDED_BY_USER}</span>
                            </p>
                        </li>
                        {data.STATUS === "Scheduled" && (
                            <li>
                                <p>
                                    Scheduled On <span>{data?.SCHEDULE_DATE}</span>
                                </p>
                            </li>
                        )}
                        {data?.ACCEPTED_DATE && (
                            <li>
                                <p>
                                    Accepted On <span>{data?.ACCEPTED_DATE}</span>
                                </p>
                            </li>
                        )}
                        {/* <li>
                            <p>
                                Schedule For <span>18 May 2024</span>
                            </p>
                        </li>
                        <li>
                            <p>
                                Submitted Date <span>18 May 2024</span>
                            </p>
                        </li> */}
                    </ul>
                </div>
            </div>

        </div >
    )
}

export default Header
